

import React, { useState } from 'react';

import { 
    DashboardLayout, GeneralTable, Button, SubmenuTooltip, MoreButton,
    Toaster 
} from "components";
import UserGroupUpdate from './userGroupUpdate/UserGroupUpdate';

import ic_add_new_group from 'assets/images/ic_add_new_group.svg';
import ic_delete from 'assets/images/ic_delete_invoices.svg';

import { func_validation } from 'functions';
import { 
    useAlertMessage, useUserGroupMapping, 
    useUserGroupPermission, useDeleteUserGroup 
} from "./hooks";
import { tableData, userGroupColumns } from "./data";

import 'assets/scss/billingPortal/modules/userManagement/userGroup.scss';



export function UserGroupPresentation(props) {
    // Props
    const { 
        getUserList_requesting, 
        userList,

        getUserGroupPermissionList_requesting, 

        getUserGroupList_requesting,

        isUserRecordUpdatedSuccessfully,
    } = props;

    const [selectedUserGroups, setSelectedUserGroups] = useState([]);
    const [seletedRowIdx, setSeletedRowIdx] = useState();

    const [isFormVisible, setIsFormVisible] = useState(false);

    
    // Alert Message
    const {
        alertMessageDisplay
    } = useAlertMessage(props);

    // User Group Permission
    const {
        setSelectedUserGroupPermissionIndexList,
        setSelectedUserGroupPermissionDetail,
        userGroupPermissionModal, setIsModalVisible_userGroupPermission,
        userGroupPermissionList_validated,
        userGroupPermissionLabels
    } = useUserGroupPermission({
        ...props,
        seletedRowIdx,
    });

    // Table Data
    const {
        userGroupList_formatted,
        userLabels,
        totalRecords
    } = tableData({
        ...props,
        userGroupPermissionList_validated
    });

    // User Group Mapping
    const {
        setSelectedUserDetail,
        setSelectedUserIndexList,
        userGroupMappingModal, setIsModalVisible_user
    } = useUserGroupMapping({
        ...props,
        userLabels
    });

    // Delete User Group Action
    const {
        deleteUserGroupModal, setIsModalVisible_deleteUserGroup
    } = useDeleteUserGroup({
        ...props,
        selectedUserGroups
    });


    return (
        <div className={"userGroup"}>
            {/* Delete User Group Modal */}
            {deleteUserGroupModal}

            {/* Users */}
            {userGroupMappingModal}

            {/* User Group Permission */}
            {userGroupPermissionModal}

            {(!isFormVisible)? (
                <DashboardLayout
                    headerTitle={"User Management"}

                    bodyClassName={"userGroup-body"}
                    body={(
                        <GeneralTable
                            className={"userGroup-table"}
                            columns={userGroupColumns.getColumns({
                                ...props,
                                setIsModalVisible_user,
                                setSelectedUserIndexList, setSelectedUserDetail,

                                setIsModalVisible_userGroupPermission,
                                setSelectedUserGroupPermissionIndexList, setSelectedUserGroupPermissionDetail,

                                setSeletedRowIdx,
                            })}
                            data={userGroupList_formatted}
                            minRows={10}

                            getTableData={props.getUserGroupList}

                            isTableRefreshRequired={isUserRecordUpdatedSuccessfully}

                            outerTableHeader={(outerTableHeader_props) => {
                                const { selectedRows: selectedUserGroups } = outerTableHeader_props;

                                return (
                                    <React.Fragment>
                                        {/* Alert Error Messages */}
                                        {alertMessageDisplay}

                                        <div className={"userGroup-table-header d-flex align-items-center justify-content-between "}>
                                            <div className={"userGroup-tableHeader-title tableHeaderTitle "}>
                                                User Group List
                                            </div>

                                            <div className={"userGroup-tableHeader-action d-flex align-items-center"}>
                                                
                                                <div className={"userGroup-tableHeaderAction-mainActionWrapper"}>
                                                    <Button
                                                        className={"userGroup-tableHeaderAction-mainAction tableHeaderButtonPadding d-flex align-items-center"}
                                                        handleOnClick={() => {
                                                            setIsFormVisible(true);
                                                        }}

                                                        isDisabled={func_validation.isUserAccessDenied(props, "Internal_UserGroup_Add")}
                                                        isDecoration_primaryTransparent
                                                    >
                                                        <React.Fragment>
                                                            <img
                                                                className={"userGroup-tableHeaderAction-icon"}
                                                                src={ic_add_new_group}
                                                                alt={"Add group icon"}
                                                            />

                                                            <span className={"userGroup-tableHeaderAction-text tableHeaderButtonText "}>Add New Group</span>
                                                        </React.Fragment>
                                                    </Button>
                                                </div>

                                                <SubmenuTooltip
                                                    buttonClassName={""}
                                                    menuItems={
                                                        [
                                                            {
                                                                icon: ic_delete,
                                                                label: "Remove User Group",
                                                                isDisabled: func_validation.isUserAccessDenied(props, "Internal_UserGroup_Delete"),
                                                                onClick: () => { 
                                                                    if (func_validation.isArrayNotEmpty(selectedUserGroups)) {
                                                                        setIsModalVisible_deleteUserGroup(true);
                                                                        setSelectedUserGroups(selectedUserGroups);
                                                                    }
                                                                    else {
                                                                        Toaster({
                                                                            type: "info",
                                                                            msg: "Please select at least 1 user group.",
                                                                        });
                                                                    }
                                                                },
                                                            },
                                                        ]
                                                    }
                                                >
                                                    <MoreButton
                                                        className={"userGroup-tableHeaderAction-moreActions"}
                                                        iconClassName={"userGroup-tableHeaderMoreAction-icon"}
                                                    />
                                                </SubmenuTooltip>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                );
                            }}

                            isTableDataLoading={getUserGroupList_requesting}

                            isUsingPagination
                            totalRecords={totalRecords}

                            isCheckboxRequired isCheckboxColumnFirst
                            isExpanderRequired={func_validation.isUserAccessGranted(props, "Internal_UserGroupMapping_View") ||
                                func_validation.isUserAccessGranted(props, "Internal_Permission_View")}
                            isColumnResizeable isRowExpanderColumnFirst
                            isTableOddRowsDarken
                        />
                    )}
                />
            ):""}

            {/* Form */}
            {isFormVisible? (
                <UserGroupUpdate
                    updateParentState_visiblity={setIsFormVisible}

                    userList={userList}
                    getUserList_requesting={getUserList_requesting}
                    userLabels={userLabels}

                    userGroupPermissionList={userGroupPermissionList_validated} 
                    userGroupPermissionLabels={userGroupPermissionLabels} 
                    userGroupPermissionList_requesting={getUserGroupPermissionList_requesting}
                />
            ):""}
        </div>
    );
}